import LocationIcon from '@/assets/icons/Location';
import { ILandById } from '@/features/lands/models/ILands';
import { useTranslation } from 'react-i18next';

export const Infos = ({
  items,
  isLoading,
}: {
  items: ILandById;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-12 gap-y-[29px]">
      <div className="col-span-12">
        {isLoading ? (
          <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
        ) : (
          <p className="text-base text-midnight-default font-medium">
            {items.farmer_name}
          </p>
        )}
      </div>

      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('farmer.stir')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <>
                <p className="text-base text-midnight-default font-medium">
                  {items.inn}
                </p>
                <a
                  href={`https://crop2.agro.uz/?search=${items?.inn}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded hover:bg-muted transition"
                >
                  <LocationIcon />
                </a>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('cadastral.number')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.cad_number}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('district')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.region_name}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('city')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <>
                <p className="text-base text-midnight-default font-medium">
                  {items.district_name}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('area')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('remaining.area')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.residue_area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">
            {t('areas.with.contours')}:
          </p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.contours_area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>
      {/* <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">
            {t('farmer.water.supply')}:
          </p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items.waterity_level}{' '}
                <span>{items.waterity_level && '%'}</span>
              </p>
            )}
          </div>
        </div>
      </div> */}
    </div>
  );
};
